import { useHttpClientContext } from '@/shared/context/HttpClientContext.tsx';
import { z } from 'zod';
import { VehicleClassSchema } from '@/shared/models/ContextDataModel/interfaces/entities/vehicle-class.ts';
import { MarketCodeSchema } from '@schuettflix/utils';

export const GetVehicleClassesResponseSchema = z.object({
    count: z.number(),
    items: z.array(
        VehicleClassSchema.omit({ payloadInTons: true }).extend({
            marketUsage: z.array(MarketCodeSchema),
        })
    ),
});

export const useGetVehicleClasses = () => {
    const { monolithClient } = useHttpClientContext();
    return {
        getVehicleClasses: () =>
            monolithClient
                .get<z.infer<typeof GetVehicleClassesResponseSchema>>(`vehicle-class/v2`, {
                    params: {
                        isActive: true,
                    },
                })
                .then(res => GetVehicleClassesResponseSchema.parse(res.data).items),
    };
};
